module.controller('samplingHomeCtrl', [ '$document', '$scope', '$rootScope', '$state', 'planSamplingService', 'alertService',
		function($document, $scope, $rootScope, $state, planSamplingService, alertService) {

			$scope.idPlanSampling = $state.params.idPlan;
			$scope.idSampling = $state.params.idSampling;
			$scope.SamplingHome = {};
			$scope.planSamplingHome = {};
			$scope.loading = false;

			$scope.goTop = function() {
				$('body,html').animate({
					scrollTop : 0
				}, 800);
			}

			$document.on('scroll', function() {
				if ($document.scrollTop() > 50) {
					var topButton = angular.element(document.getElementById('back-to-top'));
					topButton.fadeIn();
				} else {
					var topButton = angular.element(document.getElementById('back-to-top'));
					topButton.fadeOut();
				}
			});

			/**
			 * loadHomeInfo
			 */
			$scope.loadHomeInfo = function(idPlanSampling, idSampling) {
				$scope.loading = true;

				var load1 = true;
				var load2 = true;

				planSamplingService.getPlanSamplingHome(idPlanSampling).then(function(response) {
					load1 = false;
					$scope.loading = load2;
					var responseData = response.getData();
					$scope.planSamplingHome = responseData;
					$scope.idClient = responseData.client.id;
				}, function(response) {
					load1 = false;
					$scope.loading = load2;
				});

				planSamplingService.getSamplingHome(idPlanSampling, idSampling).then(function(response) {
					load2 = false;
					$scope.loading = load1;
					var responseData = response.getData();
					$scope.SamplingHome = responseData;
				}, function(response) {
					load2 = false;
					$scope.loading = load1;
				});

			};

			/**
			 * create
			 */
			$scope.create = function() {
				alertService.showSwtQuestion('Crear Cliente', function() {
					$scope.loading = true;

					var createModel = {
						name : $scope.client.name,
						businessName : $scope.client.businessName,
						idIdentificationType : $scope.client.idType.selected[0].id,
						identificationNumber : $scope.client.identificationNumber,
						mainAddress : $scope.client.mainAddress
					};

					clientService.createClient(createModel).then(function(response) {
						$scope.loading = false;
						$state.go('home.clientList');
						alertService.showSuccess('Cliente creado satisfactoriamente');
					}, function(response) {
						$scope.loading = false;
					});
				});
			};

			/**
			 * 
			 */
			$scope.update = function() {
				alertService.showSwtQuestion('Actualizar Cliente', function() {
					$scope.loading = true;

					var updateModel = {
						username : $scope.user.username,
						visible : $scope.user.visible,
						firstName : $scope.user.firstName,
						lastName : $scope.user.lastName,
						email : $scope.user.email
					};

					clientService.updateClient($scope.idUser, updateModel).then(function(response) {
						$scope.loading = false;
						$state.go('home.clientList');
						alertService.showSuccess('Cliente actualizado satisfactoriamente');
					}, function(response) {
						$scope.loading = false;
					});

				});
			};

			$scope.changeClientState = function(idClient, state) {
				if (state) {
					clientService.enableClient(idClient).then(function(response) {
						$scope.loading = false;
						alertService.showSuccess('Cliente activo nuevamente en el sistema');
					}, function(response) {
						$scope.loading = false;
					});
				} else {
					clientService.disableClient(idClient).then(function(response) {
						$scope.loading = false;
						alertService.showSuccess('Cliente inactivo');
					}, function(response) {
						$scope.loading = false;
					});
				}
			};

			$scope.getRegulation = function(idAnalysis) {
				var reg = $scope.SamplingHome.samplingsAnalysis.find(function(a) {
					return a.analysis.id == idAnalysis;
				});
				return reg.regulation;
			}

			
			var mAnalysis = undefined;
			$scope.getAnalysis = function() {
				if(angular.isDefined(mAnalysis))
					return mAnalysis;
				if (isEmpty($scope.SamplingHome))
					return [];
				var an = $scope.SamplingHome.samplingsAnalysis.sort(function(a, b) {
					return a.analysis.id - b.analysis.id;
				});
				var lastId = -1;
				mAnalysis = [];
				an.forEach(function(s) {
					if (s.analysis.id != lastId) {
						mAnalysis.push(s.analysis);
						lastId = s.analysis.id;
					}
				});
				return mAnalysis;
			}

			$scope.getTechniques = function(idAnalysis) {
				var m = $scope.SamplingHome.samplingsAnalysis.filter(function(s) {
					return s.analysis.id == idAnalysis;
				}).map(function(a) {
					return a.technique;
				});
				return m;
			}

			$scope.loadHomeInfo($scope.idPlanSampling, $scope.idSampling);

		} ]);
